import {
	intializeFilter,
	getGlobalFiltersArray_v2
} from './custom-filter';
import {
	initResisableTable_v2
} from './resizable-grid';
import {
	selectView
} from './column-settings';

window.globalTableHeads_v2 = null;
window.globalData_v2 = null;
const paddingSm_v2 = "5px";
const paddingMd_v2 = "10px";
const paddingLg_v2 = "15px";
window.density_v2 = null;
window.tempTableHeadList_v2 = null;
window.globalSortField_v2 = "";
window.globalHeight_v2 = null;
window.globalSortDirection_v2 = null;
window.globalViews_v2 = null;
window.globalCurrentView_v2 = null;
window.rowId_v2 = null;
window.msg_v2 = null;
window.GlobalId_v2 = null;
window.rowCountArr_v2 = [];
window.selectionColumn_v2 = null;
window.selectType_v2 = null;
window.elementsReturned_v2 = [];
window.hoverButtons_v2 = [];
window.newSelectionColWidth_v2 = null;
window.globalTiles = [];
window.globalSearchValue = "";
window.globalStaticColumns = [];
window.moreOptions = [];
window.actionsOptions = [];
window.columnIcons = [];
window.pillConfig = [];
window.uppercaseColumns = [];
window.user = '';
window.actionsFlag = null;
window.moreFlag = null;
let tableHeadersWidths = []; // for saving widhts to keep same widths in body
let radiotoggle = false; // for unselect of all radio buttons in tablevar selectColWIdth = 0;
let checkboxHead;
let radioHead;
let tr;
let idIndex = 0;
let checkboxtoggle = false;
let checkBox;
let totalColumns;
let width;
let selectColWIdth;
let radioButton;

function removeExtraColumns(columns) {

	for (let i = 0; i < columns.length; i++) {
		if (columns[i].length >= 1) {
			columns.splice(i, 1);
		}
	}
	return columns;
}

export const generateTableUpdated_v2 = function (uppercaseColumns, user, pillConfig, columnIcons, actionsOptions, moreOptions, staticColumns, buttons, selecttype, selectionCol, pageID, tableHeads, data, padding, height, sortField, sortDirection, views, currentView) {
	//console.log(buttons,selecttype,selectionCol,pageID,tableHeads,data,padding,height,sortField,sortDirection,views,currentView);
	let heads = removeExtraColumns(tableHeads);
	tableHeads = heads;

	if (!tableHeads) return;
	// this changes fieldname back to without pageID to transfer table data
	// to backend fieldnames otherwise it shows all data in table as undefined because of pageID appended fieldnames
	let name = tableHeads[0].fieldName.split('#');
	if (name[1] != null) {
		for (let i = 0; i < tableHeads.length; i++) {
			let name = tableHeads[i].fieldName.split('#');
			tableHeads[i].fieldName = name[0];
		}
	}
	/**********************Intialize menu div*****************************/
	// let menuDiv = document.getElementById('table-heads-menu');
	// if(menuDiv != null){
	// 	menuDiv.id = "table-heads-menu#" + pageID;
	// }
	// else{
	// 	menuDiv = document.getElementById('table-heads-menu#' + pageID);
	// }
	// menuDiv.style.display = "none";

	/**********************Set up container div height*****************************/
	if (data) {
		let containerDiv = document.getElementById('sharkTableBody');
		if (containerDiv != null) {

			containerDiv.id = "sharkTableBody#" + pageID;
		} else {

			containerDiv = document.getElementById('sharkTableBody#' + pageID);
		}
		containerDiv.id = "sharkTableBody#" + pageID;
		containerDiv.style.height = height;
	}

	/**********************Initialize global variables*****************************/
	if (window.globalTableHeads_v2 == null || window.globalStaticColumns == null) {
		window.globalTableHeads_v2 = tableHeads;
		window.globalStaticColumns = staticColumns;
	}

	window.globalHeight_v2 = height;
	window.globalSortField_v2 = sortField;
	window.globalData_v2 = data;
	window.globalSortDirection_v2 = sortDirection;
	window.density_v2 = padding;
	window.tempTableHeadList_v2 = tableHeads;
	window.globalViews_v2 = views;
	window.globalCurrentView_v2 = currentView;
	window.GlobalId_v2 = pageID;
	window.selectionColumn_v2 = selectionCol;
	window.selectType_v2 = selecttype;
	window.hoverButtons_v2 = buttons;
	window.moreOptions = moreOptions;
	window.actionsOptions = actionsOptions;
	window.columnIcons = columnIcons;
	window.pillConfig = pillConfig;
	window.user = user;
	window.uppercaseColumns = uppercaseColumns;

	/**********************Intialize Filter*****************************/
	let filterDiv = document.getElementById('custom-filter');
	if (filterDiv != null) {

		filterDiv.id = "custom-filter#" + pageID;
		intializeFilter();
	} else {
		filterDiv = document.getElementById('custom-filter#' + pageID);
	}

	/**********************Initialize Views*****************************/
	//createViews(pageID,views,currentView);
	let viewSpan = document.getElementById('sh-views');
	if (viewSpan != null) {
		viewSpan.id = "sh-views#" + pageID;
	} else {
		viewSpan = document.getElementById('sh-views#' + pageID);
	}
	viewSpan.style.display = "none";


	/*********************Creating Table********************************/
	let staticColumnsWidth = 0;
	if(window.globalStaticColumns.length==1){
		staticColumnsWidth = window.globalStaticColumns.length*7;
	}
	else if(window.globalStaticColumns.length==2){
		staticColumnsWidth = window.globalStaticColumns.length*6.45;
	}
	else if(window.globalStaticColumns.length==3){
		staticColumnsWidth = window.globalStaticColumns.length*2.5;
	}
	else if(window.globalStaticColumns.length==0){
		if(window.selectionColumn_v2==false){
			staticColumnsWidth = -5;
		}
		else{
			staticColumnsWidth = 15;
		}
	}
	else{
		staticColumnsWidth = (window.globalStaticColumns.length*2.40);
	}

	if (window.selectionColumn_v2 && data) {
		// let totalColumns = tableHeads.length;
		let selectColWIdth = 2;
		let colsTotal = selectColWIdth + staticColumnsWidth;
		let width = parseInt(((60 - colsTotal)).toFixed(2));
		// width = Math.round(width) + "%";
		selectColWIdth = selectColWIdth + "%";
		staticColumnsWidth = staticColumnsWidth + "%";
		let returnedELements = createTableHeads_v2(data, staticColumnsWidth, tableHeads, pageID, padding, sortField, sortDirection, window.selectionColumn_v2, width, selectColWIdth, window.selectType_v2);
		let radioHead = returnedELements[0];
		createTableBody_v2(staticColumnsWidth, data, pageID, padding, radioHead, tableHeads, width, selectColWIdth, window.selectionColumn_v2, window.selectType_v2, window.hoverButtons_v2);
	}

	if (!window.selectionColumn_v2 && data) {
		// let totalColumns = tableHeads.length;
		let width = (100 - staticColumnsWidth);
		width = width + "%";
		let selectColWIdth = staticColumnsWidth;
		staticColumnsWidth = staticColumnsWidth + "%";

		let returnedELements = createTableHeads_v2(data, staticColumnsWidth, tableHeads, pageID, padding, sortField, sortDirection, window.selectionColumn_v2, width, selectColWIdth, window.selectType_v2);
		let radioHead = returnedELements[0];
		createTableBody_v2(staticColumnsWidth, data, pageID, padding, radioHead, tableHeads, width, selectColWIdth, window.selectionColumn_v2, window.selectType_v2, window.hoverButtons_v2);
	}

	/**********************Initialize resizable table*****************************/
	// if(data){
	// 	initResisableTable_v2(pageID);
	// }
}

export const removeTable_v2 = function (page_id) {

	if (!window.globalData_v2) return;

	let tableHead = document.getElementById('headsTable#' + page_id);

	if (tableHead !== null) {
		while (tableHead.hasChildNodes()) {

			tableHead.removeChild(tableHead.firstChild);
		}
	}

	let tableBody = document.getElementById('bodyTable#' + page_id);
	if (tableBody !== null) {
		while (tableBody.hasChildNodes()) {

			tableBody.removeChild(tableBody.firstChild);
		}
	}
}
export const updateArrows_v2 = function (fieldName, sortDir, spanSort) {

	window.globalSortField_v2 = fieldName;
	window.globalSortDirection_v2 = sortDir;

	let event = new CustomEvent("sortEvent");
	window.dispatchEvent(event);
	spanSort.style.display = "inline-grid";

}

function addEmptyStaticHeadsForActions() {
	let flag = false;
	for (let i = 0; i < window.globalStaticColumns.length; i++) {
		const col = window.globalStaticColumns[i];
		if (col.labelName == '') {
			flag = true;
			break
		}
	}

	// adding columns for actions
	if (!flag) {
		if (window.actionsFlag) {
			window.globalStaticColumns.push({
				// 'checked': false,
				'comparisonType': '=',
				'dataType': 'input',
				'fieldName': "actions",
				"filterFlag": false,
				"filterOptions": [],
				"filterValue": "",
				"filters": [],
				"labelName": "",
				"secondValue": ""
			});
		}
		if (window.moreFlag) {
			//for more button
			window.globalStaticColumns.push({
				// 'checked': false,
				'comparisonType': '=',
				'dataType': 'input',
				'fieldName': "more",
				"filterFlag": false,
				"filterOptions": [],
				"filterValue": "",
				"filters": [],
				"labelName": "",
				"secondValue": ""
			});
		}
	}
}

function addActionsAtEnd(tableHeads) {

	if (window.actionsFlag) {
		tableHeads.push({
			'checked': true,
			'comparisonType': '=',
			'dataType': 'input',
			'fieldName': "actions",
			"filterFlag": false,
			"filterOptions": [],
			"filterValue": "",
			"filters": [],
			"labelName": "",
			"secondValue": ""
		});
	}
	if (window.moreFlag) {
		//for more button
		tableHeads.push({
			'checked': true,
			'comparisonType': '=',
			'dataType': 'input',
			'fieldName': "more",
			"filterFlag": false,
			"filterOptions": [],
			"filterValue": "",
			"filters": [],
			"labelName": "",
			"secondValue": ""
		});
	}
}

/******************************GLOBAL RETURN FUNCTIONS*************************************/

export const getGlobalTableHeads_v2 = function () {
	return window.globalTableHeads_v2;
}
export const setGlobalTableHeads_v2 = function (heads) {
	window.globalTableHeads_v2 = heads;
}
export const setGlobalStaticColumns = function (staticColumns) {
	window.globalStaticColumns = staticColumns;
}
export const getGlobalSortField_v2 = function () {
	return window.globalSortField_v2;
}
export const getGlobalSortDirection_v2 = function () {

	return window.globalSortDirection_v2;
}
export const getGlobalCurrentViewName_v2 = function () {

	return window.globalCurrentView_v2;
}
export const getGlobalDensity_v2 = function () {
	return window.density_v2;
}
export const getRowId_v2 = function () {
	return window.rowId_v2;
}
export const getMessage_v2 = function () {
	return window.msg_v2;
}
export const getRowCountArray_v2 = function () {
	return window.rowCountArr_v2;
}
export const getGlobalSearchValue_v2 = function () {
	return window.globalSearchValue;
}
export const resetGlobalSearchValue_v2 = function () {
	window.globalSearchValue = null;
	return window.globalSearchValue;
}
export const getGlobalViews_v2 = function () {
	return window.globalViews_v2;
}
export const getGlobalMoreOptions = function () {
	return window.moreOptions;
}
export const getGlobalActionsOptions = function () {
	return window.actionsOptions;
}

function checkIfActionColAlreadyExists(tableHeads) {
	var found = false;
	for (let i = 0; i < tableHeads.length; i++) {
		const column = tableHeads[i];

		if (column.fieldName == 'actions' || column.fieldName == 'more') {
			found = true;
		}
	}

	if (found) {
		return true;
	} else {
		return false;
	}
}

/************************************Table Head***************************************/
var staticFlag = true;
var dynamicFlag = true;
export const createTableHeads_v2 = function (data, staticColumnsWidth, tableHeads, pageID, padding, sortField, sortDirection, selectionColumn_v2, width, selectColWIdth, selectType_v2) {
	if (!window.globalData_v2) return;
	let headsTable = document.getElementsByTagName('table');
	headsTable = headsTable[0];

	if (headsTable != null) {
		headsTable.id = "headsTable#" + pageID;
	} else {
		headsTable = document.getElementById("headsTable#" + pageID);
	}
	// headsTable.style.boxShadow = "0px 20px 50px -22px var(--very-light-pink)";

	let tr = document.createElement('tr');
	tr.style.height = "64px";
	tr.style.borderBottom = "1px solid var(--very-light-pink)";
	tr.style.boxShadow = "0px 20px 50px -22px var(--very-light-pink)";

	let idIndex = 0;
	let checkboxHead, radioHead;
	let checkboxtoggle = false; // for select/unselect checkbox in head

	// selection head starts here
	if (selectionColumn_v2 === true) {
		if (selectType_v2 == 'radio') {
			radioHead = createRadioHead_v2(pageID, selectColWIdth, idIndex, padding, tr);
		}
		if (selectType_v2 == 'checkbox') {
			checkboxHead = createCheckboxHead_v2(data, pageID, selectColWIdth, idIndex, padding, tr, checkboxtoggle, tableHeads);
		}
	}

	// adding actions/more columns
	let actionsInStatic = true;
	if (window.actionsFlag || window.moreFlag) {
		let checkActionColFlag = checkIfActionColAlreadyExists(tableHeads);
		if (!checkActionColFlag) {
			// if (tableHeads.length <= 6 || window.globalStaticColumns.length == 0) {
			// 	actionsInStatic = false;
			// 	addActionsAtEnd(tableHeads);
			// }
			// else {
				actionsInStatic = true;
				addEmptyStaticHeadsForActions();
			// }
		}
	}

	// static columns
	if (window.globalStaticColumns.length) {
		for (let i = 0; i < window.globalStaticColumns.length; i++) {
			const column = window.globalStaticColumns[i];
			let td = document.createElement('td');
			if (column.checked) {
				td.style.fontWeight = "bold";
				td.style.backgroundColor = "#ffffff";
				td.style.borderSpacing = "0px";
				td.style.width = staticColumnsWidth;
				td.style.textAlign = 'initial';
				td.style.whiteSpace = 'nowrap';
				td.id = "a" + idIndex;

				// td.appendChild(divTag);

				if (padding == "sm") {

					td.style.padding = paddingSm_v2;
				} else if (padding == "lg") {

					td.style.padding = paddingLg_v2;
				} else {

					td.style.padding = paddingMd_v2;
				}

				let spanTag = document.createElement('span');
				spanTag.style.fontSize = "12px";
				spanTag.style.fontFamily = "Euclid Circular B";
				spanTag.style.lineHeight = "14px";
				spanTag.style.marginRight = "10px";
				let headTag = document.createElement('a');
				headTag.href = "javascript:void(0);";
				headTag.appendChild(document.createTextNode(column.labelName));
				headTag.style = "color: black;text-decoration: none;";

				spanTag.appendChild(headTag);
				td.appendChild(spanTag);

				let divTag = document.createElement('div');
				divTag.style = "width: inherit; float: right; display: contents";

				let spanSort = document.createElement('span');
				spanSort.style.display = "inline-grid";

				let divTab1 = document.createElement('div');
				divTab1.style.height = "7px";
				let divTab2 = document.createElement('div');
				divTab2.style.height = "7px";
				let sortUp = document.createElement('img');
				let sortDown = document.createElement('img');
				let search = document.createElement('img');
				sortUp.src = require("../../assets/sdt-icons/sort-up.png");
				sortDown.src = require("../../assets/sdt-icons/sort-down.png");

				sortUp.style = "margin-right: 2px; margin-left: 45%; padding: 0px; width: 10px; cursor: pointer; background: transparent; opacity: 0.3; position: relative; "

				sortDown.style.marginRight = "2px";
				sortDown.style.padding = "0px";
				sortDown.style.marginLeft = "45%";
				sortDown.style.width = "10px";
				sortDown.style.cursor = "pointer";
				sortDown.style.background = "transparent";
				sortDown.style.opacity = 0.3;
				sortDown.style.position = 'relative';


				let spanSearch = document.createElement('span');
				spanSearch.style = "display: inline-flex; vertical-align: sub; margin-right: 5px;";
				let divTab3 = document.createElement('div');
				divTab3.style.height = "7px";

				search.src = require("../../assets/search.png");
				search.style.margin = "2px";
				search.style.padding = "0px";
				search.style.marginLeft = "40%";
				search.style.width = "14px";
				search.style.cursor = "pointer";
				search.style.background = "transparent";
				search.style.opacity = 0.3;

				divTab3.appendChild(search);
				spanSearch.appendChild(divTab3);
				divTag.appendChild(spanSearch);

				// column search
				let inputValue = document.createElement('input');
				inputValue.style = "display: none;margin-top: 8px; float : left;  border: 1px solid #e1e1e1; width: 110px; height: 32px;text-indent:14px; font: 12px; font-family: Roboto; color: #979797;";
				inputValue.placeholder = 'Search..';
				inputValue.id = "col-search " + column.fieldName + pageID;
				inputValue.type = "text";
				if (getGlobalFiltersArray_v2().length > 0) {
					for (let element of getGlobalFiltersArray_v2()) {
						if (element.fieldName == column.fieldName) {
							inputValue.value = element.filterValue;
						}
					}
				}


				search.onclick = function () {
					if (inputValue.style.display == 'none') {
						inputValue.style.display = 'inline-grid';
					} else {
						inputValue.style.display = 'none';
					}
					td.appendChild(inputValue);

					inputValue.addEventListener('mouseover', function (e) {
						inputValue.style.outline = 'none';
					});

					let timeout = null;
					inputValue.addEventListener('keyup', function (e) {
						clearTimeout(timeout);

						timeout = setTimeout(function () {
							column.filterValue = inputValue.value;
							column.filterFlag = true;
							column.filters.push(column);
							if (column.filterValue) {
								window.globalFiltersArray_v2.push(column);
							}
							if (window.globalFiltersArray_v2.length > 0) {
								let index = window.globalFiltersArray_v2.findIndex((x) => x.filterValue == "");
								if (index != -1) {
									window.globalFiltersArray_v2.splice(index, 1)
								}
							}
							let event = new CustomEvent("filterEvent");
							// updateFilterTableHeads();
							// window.msg_v2=3;
							window.dispatchEvent(event);

						}, 1000);
					});

				};
				/* Static_Column_Sorting */
				sortDown.onclick = function () {
					spanSort.style.display = "inline-grid";

					/* let sortDir = "asc";
					if (window.globalSortField_v2 != column.fieldName) {
						sortDir = "desc";
					} */

					let sortDir = "desc";
					updateArrows_v2(column.fieldName, sortDir, spanSort);
					if (staticFlag == false) {
						sortDown.style.display = "none";
						divTab2.style.display = "none";
						sortUp.style.display = "inline-grid";
						divTab1.style.display = "inline-grid";
						staticFlag = true;
					}

				};

				sortUp.onclick = function () {
					spanSort.style.display = "inline-grid";

					/* let sortDir = "desc";
					if (window.globalSortField_v2 != column.fieldName) {
						sortDir = "asc";
					} */

					let sortDir = "asc";
					updateArrows_v2(column.fieldName, sortDir, spanSort);
					if (staticFlag == true) {
						sortUp.style.display = "none";
						divTab1.style.display = "none";
						sortDown.style.display = "inline-grid";
						divTab2.style.display = "inline-grid";
						staticFlag = false;

					}
				};

				divTab1.appendChild(sortUp);
				divTab2.appendChild(sortDown);
				spanSort.appendChild(divTab1);
				spanSort.appendChild(divTab2);
				divTag.appendChild(spanSort);
				td.appendChild(divTag);
				spanSort.style.display = "none";
				spanSearch.style.display = "none";


				td.addEventListener('mouseover', function (e) {
					spanSort.style.display = "inline-grid";
					spanSearch.style.display = "inline-grid";
					if (staticFlag == true) {
						sortDown.style.display = "none";
						divTab2.style.display = "none";
					} else {
						sortUp.style.display = "none";
						divTab1.style.display = "none";
						sortDown.style.display = "inline-grid";
					}
				});
				td.addEventListener('mouseout', function (e) {
					spanSort.style.display = "none";
					spanSearch.style.display = "none";
				});


				tr.appendChild(td);
				idIndex++;
			}

			if (actionsInStatic) {
				if (column.fieldName == "actions") {
					td.style.backgroundColor = "#ffffff";

					if (padding == "sm") {
						td.style.padding = paddingSm_v2;
					} else if (padding == "lg") {
						td.style.padding = paddingLg_v2;
					} else {
						td.style.padding = paddingMd_v2;
					}

					let spanTag = document.createElement('span');
					spanTag.style.fontSize = "12px";
					spanTag.style.fontFamily = "Euclid Circular B";
					let anchTag = document.createElement('a');
					anchTag.href = "javascript:void(0);";
					anchTag.appendChild(document.createTextNode('Actions'));
					anchTag.style = "color: transparent;";

					spanTag.appendChild(anchTag);
					td.appendChild(spanTag);
					tr.appendChild(td);
				}

				if (column.fieldName == "more") {
					td.style.backgroundColor = "#ffffff";
					// td.id = "a"+idIndex;

					if (padding == "sm") {

						td.style.padding = paddingSm_v2;
					} else if (padding == "lg") {

						td.style.padding = paddingLg_v2;
					} else {

						td.style.padding = paddingMd_v2;
					}

					let spanTag = document.createElement('span');
					spanTag.style.fontSize = "12px";
					spanTag.style.fontFamily = "Euclid Circular B";
					let anchTag = document.createElement('a');
					anchTag.href = "javascript:void(0);";
					anchTag.appendChild(document.createTextNode('More'));
					anchTag.style = "color: transparent;";

					spanTag.appendChild(anchTag);
					td.appendChild(spanTag);
					tr.appendChild(td);
				}
			}

			// making border for static columns
			if (i == window.globalStaticColumns.length - 1) {
				td.style.borderRight = "1px solid #e1e1e1";
			}
		}
	}

	// normal (non-static) columns

	// removing static columns from tableheads so they dont show in normal columns
	for (let i = 0; i < window.globalStaticColumns.length; i++) {
		const col = window.globalStaticColumns[i];
		if (col.fieldName != 'actions' && col.fieldName != 'more') {
			for (let j = 0; j < tableHeads.length; j++) {
				const head = tableHeads[j];
				if (col.labelName == head.labelName) {
					tableHeads.splice(j, 1);
				}
			}
		}
	}


	tableHeads.forEach((head) => {
		if (head.checked) {
			let td = document.createElement('td');


			td.style['word-break'] = "break-word";
			td.style.fontWeight = "bold";
			td.style.backgroundColor = "#ffffff";
			td.style.textAlign = 'initial';
			td.style.whiteSpace = 'nowrap';
			td.style.borderSpacing = "0px";
			td.style.cursor = "default";
			tableHeadersWidths.filter(function (e) {
				if (head.labelName == e.name) {
					td.style.width = e.width;
				}
			});

			td.id = "a" + idIndex;

			if (padding == "sm") {

				td.style.padding = paddingSm_v2;
			} else if (padding == "lg") {

				td.style.padding = paddingLg_v2;
			} else {

				td.style.padding = paddingMd_v2;
			}

			let spanTag = document.createElement('span');
			spanTag.style.fontSize = "12px";
			spanTag.style.fontFamily = "Euclid Circular B";
			spanTag.style.lineHeight = "14px";
			spanTag.style.marginRight = "10px";
			let headTag = document.createElement('a');
			headTag.href = "javascript:void(0);";
			if (head.fieldName == "actions" || head.fieldName == "more") {
				if (actionsInStatic == false) {
					if (head.fieldName == "actions") {
						// let td = document.createElement('td');
						td.style.backgroundColor = "#ffffff";

						if (padding == "sm") {
							td.style.padding = paddingSm_v2;
						} else if (padding == "lg") {
							td.style.padding = paddingLg_v2;
						} else {
							td.style.padding = paddingMd_v2;
						}

						let spanTag = document.createElement('div');
						spanTag.style.fontSize = "12px";
						spanTag.style.fontFamily = "Euclid Circular B";
						let anchTag = document.createElement('a');
						anchTag.href = "javascript:void(0);";
						anchTag.appendChild(document.createTextNode('Actions'));
						anchTag.style = "color: transparent;";

						// spanTag.appendChild(anchTag);
						td.appendChild(spanTag);
						// tr.appendChild(td);
					}

					if (head.fieldName == "more") {
						// let td = document.createElement('td');
						td.style.backgroundColor = "#ffffff";

						if (padding == "sm") {

							td.style.padding = paddingSm_v2;
						} else if (padding == "lg") {

							td.style.padding = paddingLg_v2;
						} else {

							td.style.padding = paddingMd_v2;
						}

						let spanTag = document.createElement('span');
						spanTag.style.fontSize = "12px";
						spanTag.style.fontFamily = "Euclid Circular B";
						let anchTag = document.createElement('a');
						anchTag.href = "javascript:void(0);";
						anchTag.appendChild(document.createTextNode('More'));
						anchTag.style = "color: transparent;";

						spanTag.appendChild(anchTag);
						td.appendChild(spanTag);
						// tr.appendChild(td);
					}
				}
			} else {
				headTag.appendChild(document.createTextNode(head.labelName));
			}
			headTag.style = "color: black;text-decoration: none;";

			spanTag.appendChild(headTag);
			td.appendChild(spanTag);

			let searchSortDiv = document.createElement('div');
			searchSortDiv.style = "width: inherit; float: right; display: contents";

			let spanSort = document.createElement('span');
			spanSort.style.display = "inline-grid";

			let divTab1 = document.createElement('div');
			divTab1.style.height = "7px";
			let divTab2 = document.createElement('div');
			divTab2.style.height = "7px";
			let sortUp = document.createElement('img');
			let sortDown = document.createElement('img');
			let search = document.createElement('img');
			sortUp.src = require("../../assets/sdt-icons/sort-up.png");
			sortDown.src = require("../../assets/sdt-icons/sort-down.png");

			sortUp.style = "margin-right: 2px; margin-left: 45%; padding: 0px; width: 10px; cursor: pointer; background: transparent; opacity: 0.3; position: relative; "

			sortDown.style.marginRight = "2px";
			sortDown.style.padding = "0px";
			sortDown.style.marginLeft = "45%";
			sortDown.style.width = "10px";
			sortDown.style.cursor = "pointer";
			sortDown.style.background = "transparent";
			sortDown.style.opacity = 0.3;
			sortDown.style.position = 'relative';


			let spanSearch = document.createElement('span');
			spanSearch.style = "display: inline-flex; vertical-align: sub; margin-right: 5px;";
			let divTab3 = document.createElement('div');
			divTab3.style.height = "7px";

			search.src = require("../../assets/search.png");
			search.style.margin = "2px";
			search.style.padding = "0px";
			search.style.marginLeft = "40%";
			search.style.width = "14px";
			search.style.cursor = "pointer";
			search.style.background = "transparent";
			search.style.opacity = 0.3;

			divTab3.appendChild(search);
			spanSearch.appendChild(divTab3);
			searchSortDiv.appendChild(spanSearch);

			// column search
			let inputValue = document.createElement('input');
			inputValue.style = "display: none;margin-top: 8px; float : left; border: 1px solid #e1e1e1; width: 110px; height: 32px;text-indent:14px; font: 12px; font-family: Roboto; color: #979797;";
			inputValue.placeholder = 'Search..';
			inputValue.id = "col-search " + head.fieldName + pageID;
			inputValue.type = "text";
			if (getGlobalFiltersArray_v2().length > 0) {
				for (let element of getGlobalFiltersArray_v2()) {
					if (element.fieldName == head.fieldName) {
						inputValue.value = element.filterValue;
					}
				}
			}

			search.onclick = function () {
				if (inputValue.style.display == 'none') {
					inputValue.style.display = 'inline-grid';
				} else {
					inputValue.style.display = 'none';
				}
				td.appendChild(inputValue);

				inputValue.addEventListener('mouseover', function (e) {
					inputValue.style.outline = 'none';
				});

				let timeout = null;
				inputValue.addEventListener('keyup', function (e) {
					clearTimeout(timeout);

					timeout = setTimeout(function () {
						head.filterValue = inputValue.value;
						head.filterFlag = true;
						head.filters.push(head);
						if (head.filterValue) {
							window.globalFiltersArray_v2.push(head);
						}
						if (window.globalFiltersArray_v2.length > 0) {
							let index = window.globalFiltersArray_v2.findIndex((x) => x.filterValue == "");
							if (index != -1) {
								window.globalFiltersArray_v2.splice(index, 1)
							}
						}

						let event = new CustomEvent("filterEvent");
						// updateFilterTableHeads();
						// window.msg_v2=3;
						window.dispatchEvent(event);

					}, 1000);
				});

			};

			sortDown.onclick = function () {

				spanSort.style.display = "inline-grid";

				/* let sortDir = "asc";
				if (window.globalSortField_v2 != head.fieldName) {
					sortDir = "desc";
				} */

				let sortDir = "desc";
				updateArrows_v2(head.fieldName, sortDir, spanSort);
				if (dynamicFlag == false) {
					sortDown.style.display = "none";
					divTab2.style.display = "none";
					sortUp.style.display = "inline-grid";
					divTab1.style.display = "inline-grid";
					dynamicFlag = true;
				}
			};

			sortUp.onclick = function () {
				spanSort.style.display = "inline-grid";

				/* let sortDir = "desc";
				if (window.globalSortField_v2 != head.fieldName) {
					sortDir = "asc";
				} */

				let sortDir = "asc";
				updateArrows_v2(head.fieldName, sortDir, spanSort);
				if (dynamicFlag == true) {
					sortUp.style.display = "none";
					divTab1.style.display = "none";
					sortDown.style.display = "inline-grid";
					divTab2.style.display = "inline-grid";
					dynamicFlag = false;

				}
			};

			divTab1.appendChild(sortUp);
			divTab2.appendChild(sortDown);
			spanSort.appendChild(divTab1);
			spanSort.appendChild(divTab2);
			searchSortDiv.appendChild(spanSort);
			if (head.fieldName == "actions" || head.fieldName == "more") {
				// for future
			} else {
				td.appendChild(searchSortDiv);
			}
			spanSort.style.display = "none";
			spanSearch.style.display = "none";

			td.addEventListener('mouseover', function (e) {
				spanSort.style.display = "inline-grid";
				spanSearch.style.display = "inline-grid";
				if (dynamicFlag == true) {
					sortDown.style.display = "none";
					divTab2.style.display = "none";
				} else {
					sortUp.style.display = "none";
					divTab1.style.display = "none";
					sortDown.style.display = "inline-grid";
				}
			});
			td.addEventListener('mouseout', function (e) {
				spanSort.style.display = "none";
				spanSearch.style.display = "none";
			});

			tr.appendChild(td);
			idIndex++;
		}
	});

	headsTable.appendChild(tr);
	window.elementsReturned_v2.push(radioHead);

	// saving width of heads for body column widths
	// let nodes = document.querySelectorAll('.tb-body');
	let nodes = document.getElementsByTagName('table');
	tableHeadersWidths = [];
	for (let i = 0; i < nodes[0].children[0].childElementCount; i++) {
		let temp = (nodes[0].children[0].childNodes[i].children[0].offsetWidth / nodes[0].offsetWidth) * 100;
		tableHeadersWidths.push({
			name: nodes[0].children[0].childNodes[i].childNodes[0].innerText,
			width: temp + '%',
		});
	}
	selectionColumn_v2 == true ? tableHeadersWidths.splice(0, 1) : '';

	// console.log(tableHeadersWidths);

	return window.elementsReturned_v2;
}
export const resetColumnSettings = function () {
	let settingList = document.getElementById("sh-setting-list");
	if (settingList == null) {
		settingList = document.getElementById("sh-setting-list#" + window.GlobalId_v2);
	}
	settingList.innerHTML = "";

	let divMenu = document.getElementById("table-heads-menu");
	if (divMenu == null) {
		divMenu = document.getElementById("table-heads-menu#" + window.GlobalId_v2);
	}
	divMenu.removeChild(divMenu.firstChild);
}
export const resetTilesAndViews = function () {
	let viewList = document.getElementById("sh-views");
	if (viewList == null) {
		viewList = document.getElementById("sh-views#" + window.GlobalId_v2);
	}
	viewList.removeEventListener('click', selectView, true);
	viewList.innerHTML = "";

	let tilesList = document.getElementById("tiles");
	if (tilesList == null) {
		tilesList = document.getElementById("tiles#" + window.GlobalId_v2);
	}
	tilesList.innerHTML = "";
}
export const resetFilters = function () {

	let customFilter = document.getElementById("custom-filter");
	if (customFilter == null) {
		customFilter = document.getElementById("custom-filter#" + window.GlobalId_v2);
	}
	customFilter.style.display = "none";
	customFilter.id = "custom-filter";
	customFilter.innerHTML = "";
}
export const resetGlobalVariables = function () {

	// resetColumnSettings();
	resetTilesAndViews();
	resetFilters();

	window.globalTableHeads_v2 = null;
	window.globalData_v2 = null;
	window.density_v2 = null;
	window.tempTableHeadList_v2 = null;
	window.globalSortField_v2 = "";
	window.globalHeight_v2 = null;
	window.globalSortDirection_v2 = null;
	window.globalViews_v2 = null;
	window.globalCurrentView_v2 = null;
	window.rowId_v2 = null;
	window.msg_v2 = null;
	window.GlobalId_v2 = null;
	window.rowCountArr_v2 = [];
	window.selectionColumn_v2 = null;
	window.selectType_v2 = null;
	window.elementsReturned_v2 = [];
	window.hoverButtons_v2 = [];
	window.newSelectionColWidth_v2 = null;
	window.globalTiles = [];
	window.globalSearchValue = "";
}
// export const sortDesc_v2 = function(fieldName){
// 	var sortDir = "asc";
// 	// var dispTab1 = "block";
// 	// var dispTab2 = "block";

// 	if(window.globalSortField_v2 != fieldName){

// 		sortDir = "desc";
// 		// dispTab1 = "block";
// 		// dispTab2 = "block";
// 	}

// 	updateArrows_v2(fieldName,sortDir);
// 	// sortDown.style.display = dispTab2;
// 	// sortUp.style.display = dispTab1;
// }

/*********************************Table Body******************************************/
export const createTableBody_v2 = function (staticColumnsWidth, data, pageID, padding, radiohead, tableHeads, width, selectColWIdth, selectionColumn_v2, selectType_v2, hoverButtons_v2) {
	if (data && data.length < 1) {
		let table = document.getElementsByClassName('tb-body');
		let bodyTable = table[0];
		bodyTable.style.marginTop = '5px';
		bodyTable.id = "bodyTable#" + pageID;
		let tr = document.createElement('div');
		tr.style.height = "30px";
		tr.style.padding = "10px"
		tr.style.width = "150px";
		tr.style.color = "#000000";
		tr.textContent = "No record(s) found!"
		bodyTable.appendChild(tr);
	}
	let table = document.getElementsByClassName('tb-body');
	let bodyTable = table[0];
	bodyTable.style.marginTop = '5px';


	// making header table sticky
	for (let i = 0; i < bodyTable?.children[0]?.cells?.length; i++) {
		let headerCell = bodyTable?.children[0]?.cells[i];
		headerCell.style.position = 'sticky';
		headerCell.style.top = '-1px';
		headerCell.style.zIndex = '10';
	}

	if (bodyTable != null) {
		bodyTable.id = "bodyTable#" + pageID;
	} else {
		bodyTable = document.getElementById("bodyTable#" + pageID);
	}

	let rowIndex = 0;
	data.forEach((row) => {

		let tr = document.createElement('tr');
		tr.style.borderBottom = "1px solid var(--very-light-pink)";
		tr.style.height = "60px";

		tr.addEventListener('mouseover', function (e) {
			tr.style.backgroundColor = "var(--white)";
		});

		tr.addEventListener('mouseout', function (e) {
			tr.style.backgroundColor = "#ffffff";
		});

		/****************************************************************************/
		let idIndex = 0;
		// let radiotoggle = false;  // for unselect of all radio buttons in table
		let divTab3 = document.createElement('div'); // to attach buttons to show on hover
		divTab3.style.width = "100%";
		divTab3.style.position = "relative";

		//******************************Selection Column***********************************/

		if (selectionColumn_v2 == true) {
			if (selectType_v2 == 'radio') {
				//radio button col body
				createRadioInTableBody_v2(rowIndex, padding, row, pageID, selectColWIdth, idIndex, tr);
				// radio button body ends here
			}
			if (selectType_v2 == 'checkbox') {
				//checkbox col body
				createCheckboxInTableBody_v2(rowIndex, padding, row, pageID, tr, selectColWIdth, idIndex);
				// checkbox body ends here
			}
		}

		///******************************Static Columns***********************************/
		if (window.globalStaticColumns.length != 0) {
			for (let i = 0; i < window.globalStaticColumns.length; i++) {
				const key = window.globalStaticColumns[i];
				let td = document.createElement('td');
				if (key.checked) {
					td.style['word-break'] = "break-word";
					td.style.fontSize = "12px";
					td.style.fontFamily = "Euclid Circular B";
					td.style.color = "#000000";
					td.style.borderSpacing = "0px";
					td.style.width = staticColumnsWidth;
					let containerDivTag = document.createElement('span');
					containerDivTag.style.margin = "0 !important";
					td.appendChild(containerDivTag);

					tableHeadersWidths.filter(function (e) {
						if (key.labelName == e.name) {
							td.style.width = e.width;
						}
					})

					td.style.textAlign = 'initial';
					td.style.overflowWrap = 'break-word';

					td.id = "b" + "a" + idIndex;
					td.className = td.id;

					if (padding == "sm") {

						containerDivTag.style.padding = paddingSm_v2;
					} else if (padding == "lg") {

						containerDivTag.style.padding = paddingLg_v2;
					} else {

						containerDivTag.style.padding = paddingMd_v2;
					}

					if (row[key.fieldName] !== null || row[key.fieldName] === undefined) { //if data is null then show blank instead of null
						containerDivTag.appendChild(document.createTextNode(row[key.fieldName]));
						containerDivTag.style.textTransform = "capitalize";
					} else {
						containerDivTag.appendChild(document.createTextNode(" "));
					}

					// if(){ //if data is undefined then show blank instaed of undefined
					// td.appendChild(document.createTextNode(" "));
					// }

					tr.appendChild(td);
				}

				// let td = document.createElement('td');
				let test = false;
				if (key.fieldName == "actions") {
					let actionDiv = document.createElement('div');
					// actionDiv.style.position = "relative";
					td.appendChild(actionDiv);

					tableHeadersWidths.filter(function (e) {

						if (e.name == 'Actions') {
							td.style.width = e.width;
						}
					});

					let actions = document.createElement('img');
					actions.id = 'actionsBtn#' + pageID + '-' + rowIndex;
					actions.src = require("../../assets/sdt-icons/Actions.png");
					actions.style.width = "70px";
					actions.style.height = "24px";
					actions.style.marginTop = '8px';
					actions.style.marginRight = '8px';
					actions.style.marginLeft = '12px';
					actions.style.cursor = "pointer";
					td.style.position = "relative";

					// div for dropdown
					let actionsDiv = document.createElement('div');
					actionsDiv = createDropdownMenu(pageID, actionsDiv, window.actionsOptions, 'action_input', row, actions);
					actionsDiv.style.display = 'none';

					/**********************Intialize Click Event of Actions Options Button*****************************/
					actions.addEventListener('click', (event) => {
						// close all previously opened stances of dropdown (if any)
						closePreviouslyOpenedDropdowns(actions.id);

						if (actionsDiv.style.display == "none") {

							actions.style.top = actionsDiv.offsetHeight;
							actionsDiv.style.display = "block";

						} else {
							actionsDiv.style.display = "none";
						}

						actionDiv.appendChild(actionsDiv);

					});
					if (window.actionsFlag) {
						actionDiv.appendChild(actions);
					}
					tr.appendChild(td);
				}

				if (key.fieldName == "more") {

					tableHeadersWidths.filter(function (e) {
						if (e.name == 'More') {
							td.style.width = e.width;
						}
					});


					let more = document.createElement('img');
					more.id = 'moreBtn#' + pageID + '-' + rowIndex;
					more.src = require("@/assets/More.png");
					more.style.cursor = "pointer";
					more.style.width = "18px";
					more.style.marginLeft = "12px";
					more.style.marginTop = "10px";
					td.style.position = "relative";

					// div for dropdown
					let moreDiv = document.createElement('div');
					moreDiv = createDropdownMenu(pageID, moreDiv, window.moreOptions, 'more_input', row, more);
					moreDiv.style.display = 'none';

					/**********************Intialize Click Event of More Options Button*****************************/
					more.addEventListener('click', (event) => {
						// close all previously opened stances of dropdown (if any)
						closePreviouslyOpenedDropdowns(more.id);

						if (moreDiv.style.display == "none") {
							moreDiv.style.display = "block";
						} else {
							moreDiv.style.display = "none";
						}

						td.appendChild(moreDiv);

					});

					if (window.moreFlag) {
						td.appendChild(more);
					}
					tr.appendChild(td);
				}

				// making border for static columns
				if (i == window.globalStaticColumns.length - 1) {
					td.style.borderRight = "1px solid #e1e1e1";
				}
			}
		}

		///******************************Non-Static Columns***********************************/
		tableHeads.forEach((key) => {
			if (key.checked) {

				let td = document.createElement('td');
				//td.style.border = "3px solid #f2f2f2";
				td.style['word-break'] = "break-word";
				td.style.fontSize = "12px";
				td.style.fontFamily = "Euclid Circular B";
				td.style.color = "#000000";
				td.style.textAlign = 'initial';
				td.style.whiteSpace = 'pre-wrap';
				td.style.cursor = "default";

				tableHeadersWidths.filter(function (e) {
					if (key.labelName == e.name) {
						td.style.width = e.width;
					}
				});

				td.id = "b" + "a" + idIndex;
				td.className = td.id;

				if (padding == "sm") {

					td.style.padding = paddingSm_v2;
				} else if (padding == "lg") {

					td.style.padding = paddingLg_v2;
				} else {

					td.style.padding = paddingMd_v2;
				}

				// showing icons with data
				if (window.columnIcons) {
					for (let i = 0; i < window.columnIcons.length; i++) {
						if (window.columnIcons[i].field == key.labelName) {
							if (row[key.fieldName] !== null && row[key.fieldName] !== "" && row[key.fieldName] !== undefined) {
								let span = document.createElement('span');
								let img = document.createElement('img');
								img.style.marginRight = '5px';
								if (window.columnIcons[i].icon == 'port') {
									img.src = require("../../assets/port.png");
								}
								span.appendChild(img);
								td.style.textAlign = "start";
								td.appendChild(span);
							}
						}
					}
				}

				// showing status colored
				let added = false;
				if (window.pillConfig) {
					for (let i = 0; i < window.pillConfig.length; i++) {
						const element = window.pillConfig[i];
						if (element.column == key.labelName) {
							if (row[key.fieldName] !== null) { //if data is null then show blank instead of null
								if (row[key.fieldName] == element.data) {
									let span = document.createElement('span');
									if (element.state == 'normal') {
										span.style = "white-space: nowrap;text-transform: capitalize;width: 59px;height:24px;border-radius: 12px;background-color: #f4f4f4;padding:6px;";
									} else if (element.state == 'success') {
										span.style = "white-space: nowrap;text-transform: capitalize;width: 59px;height:24px;border-radius: 12px;background-color: #dcf781;padding:7px;";
									} else if (element.state == 'error') {
										span.style = "white-space: nowrap;text-transform: capitalize;width: 59px;height:24px;border-radius: 12px;background-color: #f28989;padding:7px;";
									}

									let upperFlag = false;
									for (let s = 0; s < window.uppercaseColumns.length; s++) {
										const el = window.uppercaseColumns[s];
										if (el == key.labelName) {
											span.appendChild(document.createTextNode(row[key.fieldName].toUpperCase()));
											upperFlag = true;
										} else {
											span.appendChild(document.createTextNode(row[key.fieldName]));
											upperFlag = true;
										}
									}

									if (upperFlag == false) {
										span.appendChild(document.createTextNode(row[key.fieldName]));
									}

									added = true;
									td.appendChild(span);
								}
							} else {
								td.appendChild(document.createTextNode(" "));
							}

							if (row[key.fieldName] === undefined) { //if data is undefined then show blank instaed of undefined
								td.appendChild(document.createTextNode(" "));
							}
						}
					}
				}

				if (!added) {
					if (key.fieldName == "actions") {
						let actionDiv = document.createElement('div');
						td.appendChild(actionDiv);

						tableHeadersWidths.filter(function (e) {

							if (e.name == 'Actions') {
								td.style.width = e.width;
							}
						});

						let actions = document.createElement('img');
						actions.id = 'actionsBtn#' + pageID + '-' + rowIndex;
						actions.src = require("../../assets/sdt-icons/Actions.png");
						actions.style.width = "70px";
						actions.style.height = "24px";
						actions.style.marginTop = '8px';
						actions.style.marginRight = '8px';
						actions.style.marginLeft = '12px';
						actions.style.cursor = "pointer";
						td.style.position = "relative";

						// div for dropdown
						let actionsDiv = document.createElement('div');
						actionsDiv = createDropdownMenu(pageID, actionsDiv, window.actionsOptions, 'action_input', row, actions);
						actionsDiv.style.display = 'none';

						/**********************Intialize Click Event of Actions Options Button*****************************/
						actions.addEventListener('click', (event) => {
							// close all previously opened stances of dropdown (if any)
							closePreviouslyOpenedDropdowns(actions.id);

							if (actionsDiv.style.display == "none") {
								actions.style.top = actionsDiv.offsetHeight;
								actionsDiv.style.display = "block";
							} else {
								actionsDiv.style.display = "none";
							}

							actionDiv.appendChild(actionsDiv);

						});
						if (window.actionsFlag) {
							actionDiv.appendChild(actions);
						}
						tr.appendChild(td);
					} else if (key.fieldName == "more") {

						tableHeadersWidths.filter(function (e) {
							if (e.name == 'More') {
								td.style.width = e.width;
							}
						});


						let more = document.createElement('img');
						more.id = 'moreBtn#' + pageID + '-' + rowIndex;
						more.src = require("@/assets/More.png");
						more.style.cursor = "pointer";
						more.style.width = "18px";
						more.style.marginLeft = "12px";
						more.style.marginTop = "10px";
						td.style.position = "relative";

						// div for dropdown
						let moreDiv = document.createElement('div');
						moreDiv = createDropdownMenu(pageID, moreDiv, window.moreOptions, 'more_input', row, more);
						moreDiv.style.display = 'none';

						/**********************Intialize Click Event of More Options Button*****************************/
						more.addEventListener('click', (event) => {
							// close all previously opened stances of dropdown (if any)
							closePreviouslyOpenedDropdowns(more.id);

							if (moreDiv.style.display == "none") {
								moreDiv.style.display = "block";
							} else {
								moreDiv.style.display = "none";
							}

							td.appendChild(moreDiv);

						});

						if (window.moreFlag) {
							td.appendChild(more);
						}
						tr.appendChild(td);
					} else {
						if (row[key.fieldName] !== null) { //if data is null then show blank instead of null
							let setDataFlag = false;
							if (window.uppercaseColumns.length != 0) {
								for (let i = 0; i < window.uppercaseColumns.length; i++) {
									if (window.uppercaseColumns[i] == key.labelName) {
										if (window.uppercaseColumns[i] != key.labelName && key.fieldType != "number") {
											//converting all to lowercase no matter how in db
											td.appendChild(document.createTextNode(row[key.fieldName].toLowerCase().replace(/,/gi, "\n")));
										} else {
											// showing in uppercase
											td.appendChild(document.createTextNode(row[key.fieldName].toUpperCase().replace(/,/gi, "\n")));
										}
										setDataFlag = true;
									}
								}
							}
							if (setDataFlag == false) {
								if (window.uppercaseColumns.length == 0 && key.fieldType != "number") {
									td.appendChild(document.createTextNode(row[key.fieldName].toLowerCase().replace(/,/gi, "\n")));
								} else {
									td.appendChild(document.createTextNode(row[key.fieldName].toString().replace(/,/gi, "\n")));
								}
							}
							td.style.textTransform = "capitalize";
						} else {
							td.appendChild(document.createTextNode(" "));
						}

						if (row[key.fieldName] === undefined) { //if data is undefined then show blank instaed of undefined
							td.appendChild(document.createTextNode(" "));
						}
					}
				}

				td.appendChild(divTab3);
				tr.appendChild(td);
				idIndex++;
			}
		});

		rowIndex++;
		bodyTable.appendChild(tr);
	});

}

export const closePreviouslyOpenedDropdowns = function (currentClickedActionId) {
	let allRows = document.getElementsByTagName('td');
	let buttons = [];

	if (currentClickedActionId.includes("actionsBtn") || currentClickedActionId.includes("moreBtn") || currentClickedActionId == 'outsideClick') {
		for (let element of allRows) {
			// extracted all action buttons in table
			if (element.innerHTML.includes("actionsBtn") || element.innerHTML.includes("moreBtn")) {
				buttons.push(element);
			}
		}
	}

	//closing all dropdowns other than the one clicked
	buttons.forEach(btn => {
		if (!btn.innerHTML.includes(currentClickedActionId)) {
			if (currentClickedActionId.includes("actionsBtn") || currentClickedActionId.includes("moreBtn") || currentClickedActionId == 'outsideClick') {
				// for action dropdowns
				if (window.actionsFlag) {
					btn.childNodes[0].childNodes.forEach(child => {
						if (child.id.includes("action_input")) {
							child.style.display = 'none';
						}
					});
				}

				// for more dropdowns
				if (window.moreFlag) {
					btn.childNodes.forEach(child => {
						if (child.id.includes("more_input")) {
							child.style.display = 'none';
						}
					});
				}
			}
		}

	})
}

function createDropdownMenu(pageID, optionsDiv, optionsArr, id, row, parentImg) {
	window.rowId_v2 = row;
	optionsDiv.id = id + "#" + pageID;


	if (id.includes('more')) {
		optionsDiv.style = "z-index: 9; background: #ffffff; position: absolute; width: 112px;border: 1px solid rgb(218, 218, 218);box-shadow: 0 6px 12px rgba(0,0,0,.175);text-align: center;"
		optionsDiv.style.top = parentImg.style.height;
	} else if (id.includes('action')) {
		optionsDiv.style = "z-index: 9; background: #ffffff; position: absolute; width: auto;border: 1px solid rgb(218, 218, 218);box-shadow: 0 6px 12px rgba(0,0,0,.175);"
	}

	let list = document.createElement("ul");
	list.id = "moreList#" + pageID;
	list.style = "margin: 0;";

	optionsArr.forEach(option => {
		let listItem = document.createElement('li');
		if (listItem.id != "morelistItem#" + pageID) {
			listItem.id = "morelistItem#" + pageID;
		}

		listItem.appendChild(document.createTextNode(option));
		listItem.style = "cursor:pointer;position:relative; bottom:2px;padding: 7px;font-size:14px;font-family: Roboto;vertical-align: middle;line-height: 1;list-style-type:none;white-space: nowrap;";
		listItem.onclick = function () {
			let event = new CustomEvent("optionClickedEvent", {
				detail: {
					value: listItem.innerHTML,
					row: row
				}
			});
			window.dispatchEvent(event);
		}
		list.appendChild(listItem);
	});

	optionsDiv.appendChild(list);
	return optionsDiv;
}

/*********************************Radio Button*************************************/
export const createRadioHead_v2 = function (pageID, selectColWIdth, idIndex, padding, tr) {
	let td = document.createElement('td');
	//td.style.border = "3px solid #f2f2f2";
	td.style.width = selectColWIdth; //fixed width of radio btn col in head
	td.style['word-break'] = "break-word";
	td.style.fontWeight = "bold";
	td.style.backgroundColor = "#fff";
	td.id = "a" + idIndex;

	if (padding == "sm") {

		td.style.padding = paddingSm_v2;
	} else if (padding == "lg") {

		td.style.padding = paddingLg_v2;
	} else {

		td.style.padding = paddingMd_v2;
	}

	let radioHead = document.createElement('input');
	radioHead.type = "radio";
	radioHead.style.cursor = "pointer";
	radioHead.id = "radioHead#" + pageID;

	// clicking on radio head unselects all radio buttons
	radioHead.onclick = function () {

		let curArr = [];
		let inputs = document.getElementsByTagName("input");
		for (let a = 0; a < inputs.length; a++) {
			if (inputs[a].type === 'radio') {
				let inputElement = inputs[a].id;
				let result = inputElement.includes(pageID);
				if (result == true) {
					curArr.push(inputs[a]);
				}
			}
		}

		for (let a = 0; a < curArr.length; a++) {
			curArr[a].checked = false; // whatever row is selected gets recorded and rest all radio btns get unselected
		}
		radiotoggle = false;

		if (window.rowCountArr_v2.length > 1) { // if there are checkbox and radio selections in array
			for (let i = 0; i < window.rowCountArr_v2.length; i++) {
				let string = window.rowCountArr_v2[i];
				let result = string.search(pageID); // find the radio button string
				if (result >= 0) {
					let newArr = [];
					for (let j = 0; j < window.rowCountArr_v2.length; j++) {
						if (window.rowCountArr_v2[j] != string) {
							newArr.push(window.rowCountArr_v2[j]); //push all strings other than radio string
						}
					}
					window.rowCountArr_v2 = newArr; // has all checkbox selections now. radibutton is removed
					let getTable = document.getElementById("boxModule");
					if (typeof getTable.click == "function") {
						getTable.click.apply(getTable);
					}
				}
			}
		} else {
			window.rowCountArr_v2.pop();
			let curArr = [];
			let inputs = document.getElementsByTagName("input");
			for (let a = 0; a < inputs.length; a++) {
				if (inputs[a].type === 'radio') {
					let inputElement = inputs[a].id;
					if (inputs[a].checked == true) {
						curArr.push(inputs[a].id);
					}
				}
			}
			window.rowCountArr_v2 = curArr;
			// let getTable = document.getElementById("boxModule");
			// if(typeof getTable.click == "function"){
			// 	getTable.click.apply(getTable);
			// }
			let event = new CustomEvent("radioEvent");
			window.dispatchEvent(event);
		}

		let event = new CustomEvent("radioEvent");
		window.dispatchEvent(event);
	}

	td.appendChild(radioHead);
	tr.appendChild(td);

	return radioHead;
}
export const createRadioInTableBody_v2 = function (rowIndex, padding, row, pageID, selectColWIdth, idIndex, tr) {

	let td = document.createElement('td');
	//td.style.border = "3px solid #f2f2f2";
	td.style['word-break'] = "break-word";

	if (rowIndex == 0) {
		td.style.width = selectColWIdth; //fixed width of checkbox col in body
	}

	td.id = "b" + "a" + idIndex;
	td.className = td.id;

	if (padding == "sm") {

		td.style.padding = paddingSm_v2;
	} else if (padding == "lg") {

		td.style.padding = paddingLg_v2;
	} else {

		td.style.padding = paddingMd_v2;
	}

	// making dynamic radio button in every row
	let spanArrow2 = document.createElement('span');
	let radioButton = document.createElement('input');
	radioButton.id = row.id + '#' + pageID;
	radioButton.type = "radio";
	radioButton.style.cursor = "pointer";
	row.radiobutton = radioButton;

	radioButton.onclick = function () {
		// if window.rowCountArr_v2 has radio and checkbox saved in it
		let temp = [];
		if (window.rowCountArr_v2.length > 1) {
			for (let a = 0; a < window.rowCountArr_v2.length; a++) {
				if (!window.rowCountArr_v2[a].includes(pageID)) {
					temp.push(window.rowCountArr_v2[a]);
				}
			}
			temp.push(row.radiobutton.id);
			window.rowCountArr_v2 = temp;
			temp = [];

			// whatever row is selected gets recorded and rest all radio buttons get unselected
			let curArr = [];
			let inputs = document.getElementsByTagName("input");
			for (let a = 0; a < inputs.length; a++) {
				if (inputs[a].type === 'radio') {
					let inputElement = inputs[a].id;
					let result = inputElement.includes(pageID);
					if (result == true) {
						curArr.push(inputs[a]);
					}
				}
			}
			let prev = row.radiobutton.id;
			for (let a = 0; a < curArr.length; a++) {
				if (prev !== curArr[a].id) {
					curArr[a].checked = false; // whatever row is selected gets recorded and rest all radio buttons get unselected
				}
			}
		}

		if (window.rowCountArr_v2.length <= 1) {

			let inputs = document.getElementsByTagName("input");
			let newArr = [];

			// this saves all other radios except from the clicked table
			for (let a = 0; a < inputs.length; a++) {
				if (inputs[a].type === 'radio') {
					let inputElement = inputs[a].id;
					let result = inputElement.includes(pageID);
					if (result == false) {
						newArr.push(inputs[a]);
					}
				}
			}

			// this leaves checked rows in other tables checked
			for (let a = 0; a < newArr.length; a++) {
				if (newArr[a].checked == true) {
					// console.log(newArr[a])
					newArr[a].checked = true;
				}
			}

			// whatever row is selected gets recorded and rest all radio buttons get unselected
			let curArr = [];
			inputs = document.getElementsByTagName("input");
			for (let a = 0; a < inputs.length; a++) {
				if (inputs[a].type === 'radio') {
					let inputElement = inputs[a].id;
					let result = inputElement.includes(pageID);
					if (result == true) {
						curArr.push(inputs[a]);
					}
				}
			}

			let prev = row.radiobutton.id;
			for (let a = 0; a < curArr.length; a++) {
				if (prev !== curArr[a].id) {
					curArr[a].checked = false; // whatever row is selected gets recorded and rest all radio buttons get unselected
				}
			}

			window.rowCountArr_v2 = [];
			inputs = document.getElementsByTagName("input");
			for (let b = 0; b < inputs.length; b++) { // sending only those which are checked in all tables
				if (inputs[b].type === 'radio') {
					if (inputs[b].checked == true) {
						window.rowCountArr_v2.push(inputs[b].id);
					}
				}
			}
		}

		// let getTable = document.getElementById("boxModule");
		// if(typeof getTable.click == "function"){
		// 	getTable.click.apply(getTable);
		// }
		window.rowId_v2 = row;
		let event = new CustomEvent("radioEvent");
		window.dispatchEvent(event);

	}

	spanArrow2.style.display = "inline-block";
	spanArrow2.appendChild(radioButton);
	td.appendChild(spanArrow2);
	tr.appendChild(td);
}

/***********************************Checkbox*****************************************/
export const createCheckboxHead_v2 = function (data, pageID, selectColWIdth, idIndex, padding, tr, checkboxtoggle, tableHeads) {

	let td = document.createElement('td');

	if (window.newSelectionColWidth_v2 != null) {
		td.style.width = window.newSelectionColWidth_v2;
	} else {
		td.style.width = selectColWIdth;
	}

	td.style['word-break'] = "break-word";
	td.style.fontWeight = "bold";
	td.style.backgroundColor = "#fff";
	td.id = "a" + idIndex;

	if (padding == "sm") {

		td.style.padding = paddingSm_v2;
	} else if (padding == "lg") {

		td.style.padding = paddingLg_v2;
	} else {

		td.style.padding = paddingMd_v2;
	}

	let spanTag = document.createElement('span');
	spanTag.appendChild(document.createTextNode(""));
	td.appendChild(spanTag);

	let checkboxHead = document.createElement('input');
	checkboxHead.type = "checkbox";
	checkboxHead.style.cursor = "pointer";
	checkboxHead.id = "checkboxHead#" + pageID;

	checkboxHead.onclick = function () {
		let curArr = [];
		// this is going to save all rows of specific table
		let inputs = document.getElementsByTagName("input");
		for (let a = 0; a < inputs.length; a++) {
			if (inputs[a].type === 'checkbox') {
				let inputElement = inputs[a].id;
				let result = inputElement.includes(pageID);
				if (result == true) {
					curArr.push(inputs[a]);
				}
			}
		}

		// this is going to keep only data rows and excluding head rows
		let tempArr = [];
		for (let b = 0; b < curArr.length; b++) {
			let element = curArr[b].id;
			let str = element.split('#');
			if (str[0] >= 0) {
				tempArr.push(curArr[b]);
			}
		}
		curArr = tempArr;
		tempArr = [];

		//check all checkboxes
		if (checkboxtoggle == false) {
			// this is going to select all rows of that table
			for (let i = 0; i < curArr.length; i++) {
				curArr[i].checked = true;
				window.rowCountArr_v2.push(curArr[i].id);
			}
			checkboxtoggle = true;
		} else { //uncheck all checkboxes
			for (let i = 0; i < curArr.length; i++) {
				curArr[i].checked = false;
			}

			// this only deletes the array elements of specific table and keeps others
			let check = false;
			for (let a = 0; a < window.rowCountArr_v2.length; a++) {
				let ele = window.rowCountArr_v2[a].split('#');
				ele = ele[1];
				if (ele != pageID) {
					check = true;
					break;
				}
			}
			if (check == true) {
				let temp = [];
				for (let a = 0; a < window.rowCountArr_v2.length; a++) {
					let element = window.rowCountArr_v2[a].split('#');
					element = element[1];
					if (element != pageID) {
						temp.push(window.rowCountArr_v2[a]);
					}
				}
				window.rowCountArr_v2 = temp;
			} else {
				window.rowCountArr_v2 = []; //to empty the array since all rows will be unchecked
			}
			checkboxtoggle = false;
		}

		//this checks for any duplicates in array
		window.rowCountArr_v2 = window.rowCountArr_v2.filter(function (item, index, inputArray) {
			return inputArray.indexOf(item) == index;
		});

		// let getTable = document.getElementById("boxModule");
		// if(typeof getTable.click == "function"){
		// 	getTable.click.apply(getTable);
		// }
		// console.log(window.rowCountArr_v2)
		let event = new CustomEvent("checkboxHeadEvent", {
			detail: data
		});
		window.dispatchEvent(event);

	}

	td.appendChild(checkboxHead);
	tr.appendChild(td);

	return checkboxHead;
}

export const createCheckboxInTableBody_v2 = function (rowIndex, padding, row, pageID, tr, selectColWIdth, idIndex) {
	let td = document.createElement('td');
	//td.style.border = "3px solid #f2f2f2";
	td.style['word-break'] = "break-word";

	if (window.globalResizedElements_v2 != '') {
		for (let a = 0; a < window.globalResizedElements_v2.length; a++) {
			if (window.globalResizedElements_v2[a] == "") {
				if (selectColWIdth != window.globalResizedElements_v2[a + 1]) {
					window.newSelectionColWidth_v2 = window.globalResizedElements_v2[a + 1];
				}
			}
		}
	}

	if (rowIndex == 0) {
		if (window.newSelectionColWidth_v2 != null) {
			td.style.width = window.newSelectionColWidth_v2;
		} else {
			td.style.width = selectColWIdth;
		}
	}

	td.id = "b" + "a" + idIndex;
	td.className = td.id;

	if (padding == "sm") {

		td.style.padding = paddingSm_v2;
	} else if (padding == "lg") {

		td.style.padding = paddingLg_v2;
	} else {

		td.style.padding = paddingMd_v2;
	}

	//making dynamic checkbox in every row
	let spanArrow2 = document.createElement('span');
	let checkBox = document.createElement('input');
	checkBox.id = row.id + '#' + pageID;
	checkBox.type = "checkbox";
	checkBox.checked = false;
	checkBox.style.cursor = "pointer";
	row.checkbox = checkBox;
	checkBox.onclick = function () {
		//whatever row is selected gets recorded in array
		if (row.checkbox.checked === true) {
			window.rowCountArr_v2.push(row.checkbox.id);
		}

		// whatever row is deselected gets removed from array
		if (row.checkbox.checked === false) {
			let v = row.checkbox.id;
			let result = window.rowCountArr_v2.filter(function (ele) {
				return ele != v;
			});
			window.rowCountArr_v2 = result;
		}

		let getTable = document.getElementById("boxModule");
		if (typeof getTable.click == "function") {
			getTable.click.apply(getTable);
		}
		window.rowId_v2 = row;
		let event = new CustomEvent("checkboxEvent");
		window.dispatchEvent(event);

	}

	spanArrow2.style.display = "inline-block";
	spanArrow2.appendChild(checkBox);
	td.appendChild(spanArrow2);
	tr.appendChild(td);
}